import { render, staticRenderFns } from "./FormStockItemAlternative.vue?vue&type=template&id=3fbc161e"
import script from "./FormStockItemAlternative.vue?vue&type=script&lang=js"
export * from "./FormStockItemAlternative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormStockItemAlternative.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fbc161e')) {
      api.createRecord('3fbc161e', component.options)
    } else {
      api.reload('3fbc161e', component.options)
    }
    module.hot.accept("./FormStockItemAlternative.vue?vue&type=template&id=3fbc161e", function () {
      api.rerender('3fbc161e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/FormStockItemAlternative.vue"
export default component.exports